import React from 'react';
import styled from 'styled-components';
import { coursesData } from '../../data/coursesData';
import { colors } from '../../styles/variables';

const Section = styled.section`
  background: #fff;
  padding: 48px 24px 32px;
  text-align: center;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const Title = styled.h3`
  font-size: 26px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 32px;
`;

const ReviewList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
`;

const ReviewCard = styled.div`
  background: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 24px 20px 20px 20px;
  min-width: 260px;
  max-width: 4200px;
  flex: 1 1 260px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 600px) {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    align-items: flex-start;
  }
`;

const Stars = styled.div`
  color: #FFD600;
  font-size: 20px;
  margin-bottom: 12px;
`;

const ReviewText = styled.p`
  font-size: 16px;
  color: ${colors.primary};
  margin-bottom: 16px;
  text-align: left;
`;

const Reviewer = styled.div`
  font-size: 15px;
  color: ${colors.secondary};
  font-weight: 500;
  text-align: left;
`;

const ReviewerRole = styled.div`
  font-size: 13px;
  color: ${colors.tertiary};
  margin-top: 2px;
`;

function maskName(name) {
  return name.replace(/0/g, '〇');
}

const CourseReviewSection = ({ courseTitle }) => {
  const course = coursesData.find(c => c.title.includes(courseTitle));
  const reviews = course?.reviews || [];

  if (!reviews.length) return null;

  return (
    <Section>
      <Container>
        <Title>이 과정의 수강생 후기</Title>
        <ReviewList>
          {reviews.map((review, idx) => (
            <ReviewCard key={idx}>
              <Stars>{'★★★★★'}</Stars>
              <ReviewText>"{review.text}"</ReviewText>
              <Reviewer>- {maskName(review.name)}</Reviewer>
              {review.role && <ReviewerRole>{review.role}</ReviewerRole>}
            </ReviewCard>
          ))}
        </ReviewList>
      </Container>
    </Section>
  );
};

export default CourseReviewSection; 